import React, { FC } from 'react';
import { ReactSVG } from 'react-svg';

interface Props {
  height?: string | number;
  width?: string | number;
  src?: string;
  xml?: string;
}

const SVG: FC<Props> = ({ xml, src, ...props }) =>
  xml ? (
    // FIXME: This is dangerous. Take a look at using <Image> instead for this. e.g:
    // const base64Svg = `data:image/svg+xml;base64,${Buffer.from(logo).toString('base64')}`;
    // return <Image source={{ uri: base64Svg }} style={{ width: props.width, height: props.height }} resizeMode={'contain'} />;

    <div dangerouslySetInnerHTML={{ __html: xml }} />
  ) : src ? (
    <ReactSVG src={src} {...props} />
  ) : null;

export default SVG;
